import PropsTypes from "prop-types";

const operatorLineReturnProps = {
  type: {
    showModal: PropsTypes.bool.isRequired,
    orderToInitiate: PropsTypes.object.isRequired,
    onClose: PropsTypes.func.isRequired,
  },
};

export default operatorLineReturnProps;
